export enum PriceTypeMode {
  SHORT = 'short',
  FULL = 'full',
}
